<div class="payment-milestone">
  <div class="payment-milestone__grid">
    <dx-data-grid class="res-data-grid" height="100%" width="100%" [dataSource]="rows" keyExpr="rowID"
      [showBorders]="true" [showRowLines]="true" [hoverStateEnabled]="false" [columnAutoWidth]="true"
      [allowColumnReordering]="true" [allowColumnResizing]="true" [wordWrapEnabled]="true"
      [noDataText]="loading ? ' ' : 'No payment milestones found'" (onEditingStart)="onEditingStart($event)"
      (onCellPrepared)="onCellPrepared($event)">
      <dxo-paging [pageSize]="20"></dxo-paging>
      <dxo-pager [visible]="true" [showInfo]="true" displayMode="full" [allowedPageSizes]="[10, 20, 40]"
        [showPageSizeSelector]="true" [showNavigationButtons]="true">
      </dxo-pager>
      <dxo-scrolling mode="standard"></dxo-scrolling>
      <dxo-load-panel [enabled]="false"></dxo-load-panel>
      <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>

      <dxi-column dataField="paxGroupID" caption="Pax Group" alignment="center" [allowEditing]="false"></dxi-column>
      <dxi-column width="240px" dataField="dueDate" caption="Due Date" alignment="center" [allowEditing]="false"
        cellTemplate="dateTemplate"></dxi-column>
      <dxi-column dataField="paymentDesc" caption="Payment Milestone" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="description" caption="Description" [allowEditing]="false"></dxi-column>
      <dxi-column width="200px" dataField="milestoneAmount" caption="Milestone Amount" alignment="right"
        dataType="number" [allowEditing]="true" cellTemplate="currencyTemplate" editCellTemplate="amountEditTemplate">
        <dxi-validation-rule type="custom" [validationCallback]="validateMilestoneAmount"
          message="Amount cannot exceed the max milestone amount"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="isDateForced" caption="Forced Date" alignment="center" [allowEditing]="false"
        cellTemplate="flagTemplate"></dxi-column>
      <dxi-column dataField="isAmountForced" caption="Forced Amount" alignment="center" [allowEditing]="false"
        cellTemplate="flagTemplate"></dxi-column>

      <div *dxTemplate="let cellInfo of 'dateTemplate'">
        <div class="payment-milestone__due-date">
          <span *ngIf="cellInfo.value?.isValid">{{ cellInfo.value | formatDateTime : 'dd LLL yyyy' }}</span>
          <res-button *ngIf="cellInfo.data.canEditDate" stylingMode="outlined" text="EDIT DATE" size="small"
            [iconConfiguration]="eidosUtilityIconsService.editIcon"
            (btnClick)="openEditDueDate(cellInfo.data)">
          </res-button>
        </div>
      </div>

      <div *dxTemplate="let cellInfo of 'currencyTemplate'">
        {{ cellInfo.value | formatCurrency : cellInfo.data.currencyCod }}
      </div>

      <div *dxTemplate="let cellInfo of 'amountEditTemplate'">
        <dx-number-box class="payment-milestone__editor" [value]="cellInfo.value"
          [max]="cellInfo.data.maxMilestoneAmount" format="#,##0.00" [showSpinButtons]="false"
          (onValueChanged)="onMilestoneAmountChanged(cellInfo, $event)">
        </dx-number-box>
      </div>

      <div *dxTemplate="let cellInfo of 'flagTemplate'">
        <i [ngClass]="cellInfo.value ? 'fas fa-check-square fa-2x' : 'far fa-square fa-2x'"></i>
      </div>
    </dx-data-grid>

    <div *ngIf="loading" class="payment-milestone__loading">
      <eidos-progress-spinner></eidos-progress-spinner>
    </div>
  </div>

  <div class="d-flex w-100 justify-content-between">
    <res-button text="CLOSE" size="normal" stylingMode="contained-danger" (btnClick)="close()">
    </res-button>
    <res-button text="SAVE" size="normal" stylingMode="contained-success"
      [isDisabled]="!hasChanges || saving || loading" (btnClick)="save()">
    </res-button>
  </div>
</div>